import type { ExistingAdmin } from '@cli-types/next-adapter/commands.js'

export function formatAdminIdentity(admin: ExistingAdmin): string {
  return admin.name?.trim() ? `${admin.name} (${admin.email})` : admin.email
}
